if (!window.Eurus.loadedScript.has('mobile-dock.js')) {
  window.Eurus.loadedScript.add('mobile-dock.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store('xMobileDock', {
        // Always visible on mobile (matches V Perfumes–style bottom bar)
        showDock: typeof window !== 'undefined' && window.innerWidth <= 768,
        debounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        },
        initMobileDock() {
          const applyHeight = () => {
            const stickyAtc = document.querySelector('.sticky_add_to_cart');
            const containerMobileDock = document.getElementById("mobile-dock-container");
            const heightMobileDock = containerMobileDock ? containerMobileDock.offsetHeight : 0;
            if (!heightMobileDock) return;
            const value = heightMobileDock + "px";
            document.documentElement.style.setProperty('--pmd-height', value);
            document.documentElement.style.setProperty('--height-mobile-dock', value);
            if (stickyAtc) {
              stickyAtc.style.setProperty('--height-mobile-dock', value);
            }
            if (window.innerWidth <= 768) {
              document.body.style.paddingBottom = `calc(${value} + env(safe-area-inset-bottom, 0px))`;
            }
          };

          setTimeout(applyHeight, 0);

          const updateDock = () => {
            if ((window.xViewport && window.xViewport.innerWidth > 768) || window.innerWidth > 768) {
              this.showDock = false;
              document.body.style.paddingBottom = '';
              return;
            }
            this.showDock = true;
            applyHeight();
          };
          requestAnimationFrame(updateDock);
          window.addEventListener('resize', this.debounce(updateDock, 100), { passive: true });
        },
        setPositionSearch() {
          const search = document.getElementById('FormSearchMobileDock');
          if (search) {
            const announcement = document.getElementById('x-announcement');
            let height;
            if (announcement) {
              let sticky = announcement?.dataset.isSticky == "true";
              height = sticky ? announcement?.offsetHeight : 0;  
            } else {
              height = 0;
            }
            search.style.setProperty('--announcement-height', `${height}px`);
          }
        }
      });
    });
  });
}
